/**
 * DmlNoWhereBadge — the red "No WHERE · all rows" pill an UPDATE / DELETE
 * without a WHERE clause carries on its target row (Visual view) and beside
 * the compact popover's header. Passive, not a control: the fix is the WHERE
 * row's "Add condition", which also repeats the reach in words. Its tooltip
 * and accessible name say exactly which rows change. Renders nothing once the
 * statement has a WHERE.
 */

import { TriangleAlert } from 'lucide-react';

import { vqeCopy } from '../../ux/vqeCopy';
import type { DmlWhereScope } from './dmlWhereScope';
import { VqeTooltip } from './VqeTooltip';

export interface DmlNoWhereBadgeProps {
  readonly verb: 'UPDATE' | 'DELETE';
  /** The statement's resolved target, named in the tooltip. */
  readonly targetText: string;
  readonly scope: DmlWhereScope;
}

export function DmlNoWhereBadge({ verb, targetText, scope }: DmlNoWhereBadgeProps) {
  if (scope === 'filtered') return null;
  const hint = vqeCopy.dmlScope.hint(verb, targetText, scope);
  return (
    <VqeTooltip content={hint}>
      <span
        role="status"
        aria-label={hint}
        data-testid="vqe-dml-no-where-badge"
        data-scope={scope}
        className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-destructive px-1.5 py-0.5 text-[11px] font-semibold text-destructive-foreground"
      >
        <TriangleAlert className="h-3 w-3" aria-hidden="true" />
        {vqeCopy.dmlScope.badge(scope)}
      </span>
    </VqeTooltip>
  );
}
